module.exports = __webpack_public_path__ + "static/img/introduction-welcome-electrification.55c413e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-electrification.jpg
// module id = AK48
// module chunks = 0